import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {
    VisuallyHidden,
    useBreakpointValue
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useIntl} from 'react-intl'

const SearchResultsStatus = ({query, suggestions, ready, inputRef}) => {
    const intl = useIntl()
    const isDesktop = useBreakpointValue({base: false, lg: true})
    const [announcement, setAnnouncement] = useState({text: '', region: 1})

    useEffect(() => {
        const clearAnnouncement = () => {
            setAnnouncement((current) => (current.text ? {...current, text: ''} : current))
        }
        if (!ready || !query) {
            clearAnnouncement()
            return
        }

        const count =
            Math.min(suggestions?.productSuggestions?.length || 0, isDesktop ? 10 : Infinity) +
            Math.min(suggestions?.categorySuggestions?.length || 0, 5) +
            (Array.isArray(suggestions?.phraseSuggestion)
                ? Math.min(suggestions.phraseSuggestion.length, 5)
                : suggestions?.phraseSuggestion
                ? 1
                : 0)

        const input = inputRef?.current
        let timer
        const scheduleAnnouncement = () => {
            clearTimeout(timer)
            clearAnnouncement()
            if (inputRef && input?.value !== query) return

            // Register the region before updating it, and reschedule if the user
            // restores this query without triggering a debounced query render.
            timer = setTimeout(() => {
                if (inputRef && input?.value !== query) return
                const text = intl.formatMessage(
                    {
                        id: 'search.assistive_msg.results_updated',
                        defaultMessage:
                            'Predictive search updated for "{query}". {count, plural, =0 {No suggestions available.} one {# suggestion available.} other {# suggestions available.}}'
                    },
                    {query, count}
                )
                setAnnouncement((current) => ({text, region: 1 - current.region}))
            }, 100)
        }
        input?.addEventListener('input', scheduleAnnouncement)
        scheduleAnnouncement()
        return () => {
            clearTimeout(timer)
            input?.removeEventListener('input', scheduleAnnouncement)
        }
    }, [query, suggestions, ready, intl, inputRef, isDesktop])

    return (
        <>
            {[0, 1].map((region) => (
                <VisuallyHidden
                    key={region}
                    role="status"
                    aria-live="polite"
                    aria-atomic="true"
                    aria-relevant="additions"
                >
                    {announcement.region === region && announcement.text && (
                        <span>{announcement.text}</span>
                    )}
                </VisuallyHidden>
            ))}
        </>
    )
}

SearchResultsStatus.propTypes = {
    query: PropTypes.string,
    suggestions: PropTypes.object,
    ready: PropTypes.bool,
    inputRef: PropTypes.object
}

export default SearchResultsStatus
